module.exports = __webpack_public_path__ + "img/daichao1.71f4b8d5.png";